import { TOKEN_KEY, TOKEN_EXPIRES_AT_KEY } from '@/constants/config';
import { expirareLaPrimire } from './expirare-token';

/**
 * SINGURUL loc care scrie tokenul de acces in `localStorage` — si, odata cu el, expirarea.
 *
 * Erau doua scrieri: `updateToken` din `auth-provider-v2` (login, OTP, inscriere, reinscriere,
 * schimbare de parola) punea doar tokenul, iar refresh-ul din `client.ts` punea si expirarea. De
 * aici prima ora fara reimprospatare proactiva — vezi `expirare-token.ts`.
 *
 * Se cheama doar cu un token ABIA PRIMIT de la server: expirarea se socoteste de la `Date.now()`.
 * `expiresIn` (secunde) e optional; fara el, durata se citeste din token.
 */
export function salveazaTokenDeAcces(token: string, expiresIn?: number | null): void {
    localStorage.setItem(TOKEN_KEY, token);
    const expiraLa = expirareLaPrimire(token, Date.now(), expiresIn);
    // Sir gol cand nu se poate afla, ca la logout: fara reimprospatare proactiva, nu cu una gresita.
    localStorage.setItem(TOKEN_EXPIRES_AT_KEY, expiraLa === null ? '' : String(expiraLa));
}
